import { bl_fi_generic_doc_einvoice_posting_queue_RowClass } from '../../dbschema/bl_fi_generic_doc_einvoice_posting_queue.model';
import { BaseContainerModel } from '../base-container.model';

export class GenericDocEInvoicePostingQueueContainerModel extends BaseContainerModel {
    bl_fi_generic_doc_einvoice_posting_queue: bl_fi_generic_doc_einvoice_posting_queue_RowClass = new bl_fi_generic_doc_einvoice_posting_queue_RowClass();
}
